import React from 'react';
import { GiftIcon, DotIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaBlock } from '../CtaBlock';
import { bonuses } from '../../data/content';
export function BonusesSection() {
  return <section className="bg-navy-50 py-14 sm:py-20" aria-labelledby="bonuses-title" data-id="element-87" data-mp="qeac0agskpy1">
      <div className="mx-auto w-full max-w-5xl px-2 sm:px-6" data-id="element-88" data-mp="vcvbu8s4t7ly">
        <div className="px-2 sm:px-0" data-id="element-89" data-mp="1j1ocgijp83mw">
        <SectionHeading eyebrow="Professional consultation kit" title={<span id="bonuses-title" data-id="element-91" data-mp="1nzg4dckcfpr3">
              Plus, you’ll receive 5 clinical tools completely <span className="text-clinic-600" data-id="element-92" data-mp="19cd4x0cgn714">FREE</span>
            </span>} subtitle="Because making better clinical decisions also depends on having the right tool at the right moment." data-id="element-90" data-mp="1j2pooqcgaw67" />
        </div>

        <div className="mt-9 space-y-5" data-id="element-93" data-mp="21yph229cc1qb">
          {bonuses.map(bonus => <article key={bonus.index} className="overflow-hidden rounded-3xl border border-navy-100 bg-white" data-id="element-94" data-mp="26rr26s054xic">
              <div className="flex flex-wrap items-center justify-between gap-2 border-b border-navy-100 bg-white px-4 py-3 sm:px-6" data-id="element-95" data-mp="2h6fllyg8bxif">
                <span className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-navy-800 sm:text-xs" data-id="element-96" data-mp="2vwdcwn9gh3bu">
                  <GiftIcon className="h-4 w-4 text-clinic-600" aria-hidden="true" data-id="element-97" data-mp="2r3ahsap15ltj" />
                  Bonus #{bonus.index}
                </span>
                <span className="flex items-center gap-2" data-id="element-98" data-mp="2zxf20b9nrz03">
                  <span className="text-[11px] font-semibold text-navy-400 line-through sm:text-xs" data-id="element-99" data-mp="2zyzvryo5fdww">
                    Value: {bonus.value}
                  </span>
                  <span className="rounded-full bg-clinic-500 px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-white" data-id="element-100" data-mp="39week4xjoesd">
                    Free today
                  </span>
                </span>
              </div>
              <div className="border-b border-navy-100 bg-white" data-id="element-101" data-mp="1fj52c5dm6f6f">
                <img src={bonus.image} alt={`${bonus.title} — printed guide, tablet and phone preview`} className="block w-full" loading="lazy" data-id="element-102" data-mp="256iugfcb7450" />
              </div>
              <div className="p-4 sm:p-6" data-id="element-103" data-mp="2j4z1k7e32wno">
                <h4 className="text-balance text-[16px] font-black leading-tight text-navy-900 sm:text-xl" data-id="element-104" data-mp="2j5s04l2w2fuq">
                  {bonus.title}
                </h4>
                <p className="mt-3 text-pretty text-[14px] leading-relaxed text-navy-700 sm:text-base" data-id="element-105" data-mp="2s5f3vdj3bxqy">
                  {bonus.description}
                </p>
                <p className="mt-4 text-[10px] font-black uppercase tracking-[0.14em] text-clinic-700 sm:text-[11px]" data-id="element-106" data-mp="2wx5elklxwniw">
                  {bonus.listLabel}
                </p>
                <ul className="mt-2 flex flex-wrap gap-2" data-id="element-107" data-mp="36vuninvuyxn0">
                  {bonus.items.map(item => <li key={item} className="flex items-center gap-1 rounded-full bg-navy-50 px-3 py-1.5 text-[12.5px] font-semibold text-navy-800 sm:text-sm" data-id="element-108" data-mp="3bu5xcym5l858">
                      <DotIcon className="h-4 w-4 shrink-0 text-clinic-600" aria-hidden="true" data-id="element-109" data-mp="v9kgaqdavgjo" />
                      {item}
                    </li>)}
                </ul>
                {bonus.closing && <p className="mt-4 text-[13.5px] font-medium italic leading-snug text-navy-600 sm:text-[15px]" data-id="element-110" data-mp="1ixbs7suxhrkf">
                    {bonus.closing}
                  </p>}
              </div>
            </article>)}
        </div>

        <div className="mx-2 mt-10 rounded-3xl bg-navy-900 p-5 text-center sm:mx-0 sm:p-8" data-id="element-111" data-mp="195644u7sruai">
          <p className="text-base font-black text-white sm:text-xl" data-id="element-112" data-mp="147mc8ri6fj03">
            You’re not buying PDFs today.
          </p>
          <p className="mt-2 text-[15px] font-semibold text-navy-100 sm:text-base" data-id="element-113" data-mp="21p4nxv1dtqvu">
            You’re getting a system that can support you through hundreds of consultations.
          </p>
          <p className="mt-4 text-[14px] leading-relaxed text-navy-200 sm:text-base" data-id="element-114" data-mp="1hgmxka7xrxaf">
            Every algorithm. Every protocol. Every checklist. Every clinical tool — designed to help
            you organize clinical decisions faster and with greater confidence when it matters most:
            when the patient is sitting in front of you.
          </p>
          <p className="mt-5 inline-block rounded-full bg-clinic-500 px-4 py-2 text-[12px] font-black uppercase tracking-wide text-white sm:text-sm" data-id="element-115" data-mp="2062z90vcxvsf">
            $140 USD in clinical tools included at no additional cost
          </p>
        </div>

        <div className="px-2 sm:px-0" data-id="element-116" data-mp="1qddyp11ci2bv">
          <CtaBlock kicker="Everything the system includes — plus all five clinical tools." label="👉 I want the system + all 5 bonuses" data-id="element-117" data-mp="1vdjki0kxoum1" />
        </div>
      </div>
    </section>;
}